module.exports = __webpack_public_path__ + "media/images/500-d6cb9548e2de1469f312bdd23b3926f1.jpg";